<template>
  <div>
    <AlterFormLayout
      modalId="payment-routing-add-modal"
      formTitle="Adicionar direcionamento de pagamento"
      cancelButtonText="Cancelar"
      submitButtonText="Enviar solicitação direcionamento de pagamento"
      :onSubmitEvent="onSubmit"
      :disableEvent="this.$store.getters.isAdmin"
    >
      <template #content>
        <PaymentRoutingForm newRegister="true" />
      </template>
    </AlterFormLayout>
    <success-modal
      ref="success-modal"
      description="Sua solicitação de solicitação de novo direcionamento de pagamento foi enviada."
      buttonText="Ok, entendi!"
      subdescription="Os dados inseridos serão analisados e cadastrados após a validação."
      :protocol="this.protocol"
    />
  </div>
</template>

<script>
import PaymentRoutingForm from "./PaymentRoutingForm.vue";
import AlterFormLayout from "../../../../../layouts/AlterFormLayout.vue";
import SuccessModal from "../../../../../components/base-modals/SuccessModal.vue";
import { addPaymentRouting } from "../../../../../services/payment-options/paymentOptionsService";

export default {
  components: {
    AlterFormLayout,
    PaymentRoutingForm,
    SuccessModal,
  },
  data() {
    return {
      protocol: "",
    };
  },
  methods: {
    async onSubmit(formData) {
      this.protocol = await addPaymentRouting(formData, formData.files);
      const modal = this.$refs["success-modal"].$children[0];
      modal.show();
    },
  },
};
</script>
